import CompanyFragilityEdit from './CompanyFragilityEdit'
import CompanyFragilityMain from './CompanyFragilityMain'
import CompanyFragilityNew from './CompanyFragilityNew'

export default {
  CompanyFragilityEdit,
  CompanyFragilityMain,
  CompanyFragilityNew,
}
